export const TERMS_VERSION = "2026-05-29";
export const PRIVACY_VERSION = "2026-06-01";

export const TERMS_LAST_UPDATED = "May 29, 2026";
export const PRIVACY_LAST_UPDATED = "June 1, 2026";

export const LEGAL_CONTACT_EMAIL = "privacy@sproutly.space";
